import {Entity} from '../../core/commons/entity';

export class AbogadoContact implements Entity {
    id: number;
    email: string;
    firstname: string;
    lastname: string;


    constructor(value: Object = {}) {
        Object.assign(this, value);
    }
}



// WEBPACK FOOTER //
// ./src/app/fiscalia/domain/abogado-contact.ts